<template>
    <div class="sty-section" :class="bemFacets">
        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="sty-section--example">
            <div class="grid--container">
                <div class="grid--row sty-section--row">
                    <div class="grid--col sty-section--col">
                        <div class="sty-section--bp-displays" v-if="bridgeData">
                            <div class="sty-section--bp-display"
                                    :class="['sty-section--bp-display__' + key]"
                                    v-for="(mq, key) in bridgeData"
                                    :key="key"/>
                        </div>
                    </div>
                </div>
                <div class="grid--row sty-section--row">
                    <div class="grid--col sty-section--col">
                        <table class="sty-section--bp-infos">
                            <tr class="sty-section--bp-info">
                                <td class="sty-section--bp-td-title">
                                    Displayed:
                                </td>
                                <td class="sty-section--bp-name"/>
                            </tr>
                            <tr class="sty-section--bp-info">
                                <td class="sty-section--bp-td-title">
                                    Dimension - min:
                                </td>
                                <td class="sty-section--bp-dimensions sty-section--bp-dimensions__min"/>
                            </tr>
                            <tr class="sty-section--bp-info">
                                <td class="sty-section--bp-td-title">
                                    Dimension - max:
                                </td>
                                <td class="sty-section--bp-dimensions sty-section--bp-dimensions__max"/>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StyHeader from 'framework/styleguide/header';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        components: {
            StyHeader,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
            bridgeData: {
                type: Object,
                required: true,
            },
        },
    };
</script>
